module.exports = __webpack_public_path__ + "img/collection-diamondJewelryExclusive@2x.69f08c9.jpg";